// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper__YXrt","Links":"Hero__Links_2IlUS","Year":"Hero__Year_3PZs1","Title":"Hero__Title_23jRF"};